import { map, Observable } from 'rxjs';

export function fromResizeEvent(element: HTMLElement): Observable<DOMRectReadOnly> {
    return new Observable((observer) => {
        // Emit the initial value
        observer.next(element.getBoundingClientRect());

        const resize = new ResizeObserver((entries) => entries.forEach(({ contentRect }) => observer.next(contentRect)));

        resize.observe(element, { box: 'border-box' });

        return () => resize.unobserve(element);
    });
}

export function screenBoundsToRelative(element: HTMLElement, elementScreenBounds: DOMRect): DOMRect {
    if (!element.parentElement) return elementScreenBounds;

    const parentScreenBounds = element.parentElement.getBoundingClientRect();

    return new DOMRect(
        elementScreenBounds.x - parentScreenBounds.x,
        elementScreenBounds.y - parentScreenBounds.y,
        elementScreenBounds.width,
        elementScreenBounds.height
    );
}

export function relativeElementBounds(element: HTMLElement): Observable<DOMRect> {
    return fromResizeEvent(element).pipe(
        map(() => ({
            bounds: element.getBoundingClientRect(),
            isScreenBounds: hasAbsolutePosition(element)
        })),
        map(({ bounds, isScreenBounds }) => (isScreenBounds ? screenBoundsToRelative(element, bounds) : bounds)),
        map((bounds) => compensateBoundsForTopBarComponentHeight(bounds)),
        map((bounds) => compensateBoundsForScroll(bounds))
    );
}

function hasAbsolutePosition({ style: { position } }: HTMLElement): boolean {
    return position === 'absolute';
}
function compensateBoundsForTopBarComponentHeight(bounds: DOMRect): DOMRect {
    let topBarHeight = 56;
    //get element by tag name
    const topBarElements = document.getElementsByTagName('p-main-header');
    if (topBarElements && topBarElements.length > 0 && topBarElements[0] && topBarElements[0].getBoundingClientRect()) {
        topBarHeight = topBarElements[0].getBoundingClientRect().height + topBarElements[0].getBoundingClientRect().top;
    }
    return new DOMRect(bounds.x, bounds.y - topBarHeight, bounds.width, bounds.height);
}

function compensateBoundsForScroll(bounds: DOMRect): DOMRect {
    let rec = document.firstElementChild?.getBoundingClientRect();
    if (rec?.x) {
        return new DOMRect(bounds.x - rec.x, bounds.y, bounds.width, bounds.height);
    }
    return bounds;
}
